import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import useSession from "../hooks/useSession";


const Callback = () => {
  const navigate = useNavigate();

  const { isLoggedIn } = useSession();

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/analytics');
    }
  }, [isLoggedIn]);
  return <main></main>;
};
export default Callback;
